// eslint-disable-next-line
export const TABLE_DATA_FORMAT = [
    {
        captionSelector: 'timerange',
        valueSelector: 'inYears',
        type: 'date',
    },
    {
        captionSelector: 'released',
        valueSelector: 'releasedAmount',
        type: 'money',
    },
    {
        captionSelector: 'pumped',
        valueSelector: 'drawnAmount',
        type: 'money',
    },
    {
        captionSelector: 'returned',
        valueSelector: 'refundedAmount',
        type: 'money',
    },
    {
        captionSelector: 'usedup',
        valueSelector: 'consumptionAmount',
        type: 'money',
    },
]
